import AdvancedController from "./advanced-controller"
import Chart from 'chart.js/auto';
import { Breakpoints } from '../utils/breakpoints';
import ChartDataLabels from 'chartjs-plugin-datalabels';

export default class ChartController extends AdvancedController {

  static targets = [];

  static values = {
    data: Array,
    label: String,
    units: String,
    type: String,
    width: Number
  }

  connect() {
    super.connect();

    Chart.defaults.set('plugins.datalabels', {
      color: '#000000',
      font: {
        size: 24,
        weight: 'bold',
        family: '"Cera Stencil Pro"'
      }
    });

    // create chart placeholder without animation
    this.chartInstance = this.createChart(false);
    // hide the chart initially
    this.element.style.opacity = 0;

    this.breakpoints = new Breakpoints();
    this.breakpoints.on('breakpoint_changed', this.onBreakpointChanged.bind(this));
    this.onBreakpointChanged.bind(this)();
  }

  onBreakpointChanged() {
    if (this.breakpoints.breakpointDown('sm')) {
      this.element.parentElement.style.width = '100%';
    } else {
      this.element.parentElement.style.width = `${this.widthValue}%`;
    }
  }

  inViewport() {
    // temporarily destroy the chart
    if (this.chartInstance) {
      this.chartInstance.destroy();
    }
    // create animated chart
    this.chartInstance = this.createChart(true);
    //fade in the chart
    this.element.style.transition = 'opacity 0.5s ease-in-out';
    this.element.style.opacity = 1;
  }

  getContrastColor({ red, green, blue }) {
    // Calculate the relative luminance of the color
    const luminance = (0.299 * red + 0.587 * green + 0.114 * blue) / 255;
    // Return black for light colors and white for dark colors
    return luminance > 0.5 ? '#000000' : '#FFFFFF';
  }

  createChart(withAnimation = false) {
    // super.connect();

    const formatter = new Intl.NumberFormat('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })
    const data = this.dataValue;

    const chartConfig = {
      plugins: [ChartDataLabels],
      type: this.typeValue || 'bar',
      data: {
        labels: data.map(row => row.x),
        datasets: [
          {
            label: this.labelValue,
            data: data.map(row => row.y),
            barPercentage: data.length >= 5 ? 0.75 : 0.5, // set bar width to 50% of the available space
            backgroundColor: data.map(row => {
              return `rgba(${row.bgColor.red}, ${row.bgColor.green}, ${row.bgColor.blue}, ${row.bgColor.alpha})`
            }),
            datalabels: {
              color: data.map(row => {
                return this.getContrastColor(row.bgColor);
              })
            }
          }
        ]
      },
      options: {
        animation: withAnimation ? undefined : false, // disable animation if not in viewport
        responsive: true,      // enable responsiveness (default)
        maintainAspectRatio: false,
        locale: "de",
        onResize: this.handleResize,

        plugins: {
          datalabels: {
            formatter: (value, context) => {
              let returnValue = this.unitsValue ? ` ${this.unitsValue}` : ''
              return `${parseFloat(value).toLocaleString('de-DE')}` + returnValue
            }
          },
          legend: {
            position: 'bottom',
            display: this.typeValue == "pie",
            padding: 300,
            labels: {
              padding: 24,
              font: {
                family: '"Cera Stencil Pro"',
                size: 24,
                weight: 'bold',
                lineHeight: 1.2
              },
            }
          },
          tooltip: {
            backgroundColor: 'rgba(255,255,255,0.9)', // tooltip background color
            titleColor: '#000000',
            bodyColor: '#000000',
            titleFont: {
              family: '"Cera Stencil Pro"',
              size: 36,
              weight: 'bold',
              lineHeight: 1.2
            },
            bodyFont: {
              family: '"Cera Stencil Pro"',
              size: 24,
              weight: 'normal'
            },
            cornerRadius: 0,
            displayColors: false,
            borderColor: '#000000',
            padding: 24,
            borderWidth: 2,
            callbacks: {
              label: (context) => {
                return context.dataset.label + ': ' + parseFloat(context.raw).toLocaleString('de-DE') + ' ' + this.unitsValue
              }
            }
          }
        }
      }
    }

    if (this.typeValue !== 'pie') {
      chartConfig.options.scales = {
        x: {
          ticks: {
            font: {
              size: 36, // Font-Größe in px
              family: 'Cera Stencil Pro', // Hier deine gewünschte Schriftart
              weight: 'bold'
            }
          }
        },
      }
    }

    return new Chart(
      this.element.querySelector('canvas'),
      chartConfig
    );
  }

  handleResize(chart, size) {
    if (chart.config.type === 'bar') {
      if (size.width < 680) {
        chart.options.scales.x.ticks.font.size = 20
        chart.options.plugins.tooltip.titleFont.size = 20
        chart.options.plugins.tooltip.bodyFont.size = 16
        chart.options.plugins.tooltip.padding = 10
        if (chart.data.labels.length >= 5) {
          chart.options.plugins.datalabels.display = false
        }
      } else {
        chart.options.scales.x.ticks.font.size = 36
        chart.options.plugins.tooltip.titleFont.size = 36
        chart.options.plugins.tooltip.bodyFont.size = 24
        chart.options.plugins.tooltip.padding = 24
        if (chart.data.labels.length >= 5) {
          chart.options.plugins.datalabels.display = true
        }
      }
    }
  }

}